import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import HeroSection from "../components/home/HeroSection";
import ServicesSection from "../components/home/ServicesSection";
import SystemOverview from "../components/home/SystemOverview";
import CRMSection from "../components/home/CRMSection";
import ResultsSection from "../components/home/ResultsSection";
import AppSection from "../components/home/AppSection";
import WhyChooseSection from "../components/home/WhyChooseSection";
import PricingSection from "../components/home/PricingSection";
import ContactSection from "../components/home/ContactSection";

const HomePage = () => {
  return (
    <div className="min-h-screen bg-black">
      <Header />
      <main>
        <HeroSection />
        <ServicesSection />
        <SystemOverview />
        <CRMSection />
        <ResultsSection />
        <AppSection />
        <WhyChooseSection />
        <PricingSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;